// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinnerQ_loader__1eIGq","l2":"SpinnerQ_l2__2OhZx","dispatch":"SpinnerQ_dispatch__D8D-P"};